var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-card',{class:_vm.classNames},[_c('mdb-card-body',{class:_vm.small && 'p-2'},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }